module.exports = __webpack_public_path__ + "media/images/official/top_mv4_sp-26adbe3b6f97271d2adaafebb110250f.jpg";